<template>
  <el-dialog
    append-to-body
    width="700px"
    title="详情"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-descriptions
      title=""
      :column="1"
      border
      style="margin-top: 10px"
      size="small"
    >
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="师傅"
        >{{ viewInfo.name }}</el-descriptions-item
      >
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="账号"
        >{{ viewInfo.account }}</el-descriptions-item
      >
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="服务类型"
        >{{
          viewInfo && viewInfo.kind_arr && viewInfo.kind_arr.length
            ? viewInfo.kind_arr.map((item) => item.name).join("、")
            : ""
        }}</el-descriptions-item
      >
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="服务时间"
      >
        <span v-if="viewInfo.is_time == 2">不限时间</span>
        <span v-else>
          <span v-if="viewInfo.start_time == viewInfo.end_time">{{ viewInfo.start_time }}</span>
          <span v-else>
            {{ viewInfo.start_time }}至{{ viewInfo.end_time }}
          </span>
        </span>
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="期望报酬"
      >
        <!-- 是否议价 1:面议 2:支持议价 3:不议价 -->
        <div v-if="viewInfo.is_discuss == 3">
          <div v-if="Number(viewInfo.amount)">
            {{ viewInfo.amount }}元{{ viewInfo.amount_type_str ? "/" : ""
            }}{{ viewInfo.amount_type_str }}
          </div>
          <div style="font-size: 12px">不议价</div>
        </div>
        <div v-if="viewInfo.is_discuss == 2">
          <div v-if="Number(viewInfo.amount)">
            {{ viewInfo.amount }}元{{ viewInfo.amount_type_str ? "/" : ""
            }}{{ viewInfo.amount_type_str }}
          </div>
          <div style="font-size: 12px">可议价</div>
        </div>
        <div v-if="viewInfo.is_discuss == 1">
          <div v-if="Number(viewInfo.amount)">
            {{ viewInfo.amount }}元{{ viewInfo.amount_type_str ? "/" : ""
            }}{{ viewInfo.amount_type_str }}
          </div>
          <div style="font-size: 12px">面议</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="期望区域"
        >{{ viewInfo.province_str }}{{ viewInfo.city_str
        }}{{
          viewInfo.area_arr.length
            ? "(" + viewInfo.area_arr.map((item) => item.name).join("、") + ")"
            : ""
        }}</el-descriptions-item
      >
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="服务介绍"
        >{{ viewInfo.desc }}</el-descriptions-item
      >
      <el-descriptions-item
        :labelStyle="labelStyle"
        :contentStyle="contentStyle"
        label="看过人数"
        >{{ viewInfo.view_count }}</el-descriptions-item
      >
    </el-descriptions>
    <div style="margin-top: 10px; margin-bottom: 10px">查看人员</div>
    <el-table
      :data="table.data"
      ref="tableDom"
      :max-height="300"
      border
      style="width: 100%"
      v-loading="table.loading"
      :show-header="false"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
      :header-cell-style="{ background: '#f5f5f5' }"
    >
      <el-table-column label="头像" prop="name" width="80">
        <template #default="{ row }">
          <div style="display: flex; justify-content: center">
            <el-image
              :src="row.avatar || require('@/assets/img/sex0.png')"
              style="width: 40px; height: 40px"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="nickname" align="center">
      </el-table-column>
      <el-table-column label="手机号" prop="account" align="center">
      </el-table-column>
      <el-table-column label="消耗" prop="pay_type" align="center">
        <template #default="{ row }">
          <span v-if="row.pay_type == 1">消耗{{ row.value }}积分</span>
          <span v-if="row.pay_type == 2">支付{{ row.value }}元</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" prop="create_time" align="center">
      </el-table-column>
    </el-table>
    <div class="pagination__wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
export default {
  mixins: [mixinTable],
  data() {
    return {
      visible: false,
      loading: false,
      labelStyle: { width: "100px", textAlign: "center" },
      contentStyle: { width: "300px" },
      info: {},
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      viewInfo: {},
    };
  },
  methods: {
    getDetail(row) {
      this.info = row;
      this.getTable();
    },
    getTable() {
      let _params = { ...this.table.params, id: this.info.id };
      this.table.loading = true;
      this.$http
        .get("/admin/flex_position/info", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.view_list.list;
            this.table.total = res.data.view_list.total;
            this.viewInfo = res.data.info;
            this.$nextTick(() => {
              this.$refs.tableDom.doLayout();
            });
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    reset(done) {
      this.table = {
        loading: false,
        params: { page: 1, count: 10 },
        data: [],
        total: 0,
      };
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
